import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

export default function NotFoundPage() {
  return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center">
      <div className="text-sm font-mono text-slate-400 mb-2">404</div>
      <h1 className="text-3xl font-bold text-slate-900 mb-3">Page not found</h1>
      <p className="text-slate-600 mb-8">
        This project may not exist, or the link may be stale. Try opening a
        fresh project URL from your customer AI.
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 rounded-lg bg-ub-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-ub-blue-700 transition"
      >
        <ArrowLeft className="h-4 w-4" />
        Back to home
      </Link>
    </div>
  )
}
